export default {
    name: "Sentence",
    props: {
        sentence: {
            type: Object,
            required: true
        },
        word: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        pattern() {
            if (this.word === null) return null;
            return new RegExp(this.word, "gi");
        },
        styledSentence() {
            const { sentence } = this.sentence;
            if (this.word === null) return sentence;
            return sentence.replace(
                this.pattern,
                match => `<span class="emphasis">${match}</span>`
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Sentence/Sentence.js